<template>
  <div class="peng_jiapu">
    <div class="w1200 content">
      <div class="content_tip">
        <img :src="tipsimg3" alt="">
      </div>
      <div class="showlist">
        <div class="showlistBox">
          <img :src="peng_jiapu_bgc" alt="">
          <div style="position: absolute;top: 0;left: 0;">
            <div v-for="(item,index) in bookData" :key="index" class="lilist">
              <img :src="item.COVER" alt="" @click="goDetail(item.SHOW_RES_ID,item.SHOW_TYPE)">
              <p>{{ item.SHOW_TITLE }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="peng_jiapu_nav">
        <ul>
          <li :class="currentIndex==1?'avtiveli':'noactiveli'" @click="handelNav(1)">
            <span>谱文</span>
          </li>
          <li :class="currentIndex==2?'avtiveli':'noactiveli'" @click="handelNav(2)">
            <span>谱系</span>
          </li>
          <li :class="currentIndex==3?'avtiveli':'noactiveli'" @click="handelNav(3)">
            <span>人物</span>
          </li>
          <li :class="currentIndex==4?'avtiveli':'noactiveli'" @click="handelNav(4)">
            <span>书页</span>
          </li>
          <li :class="currentIndex==5?'avtiveli':'noactiveli'" @click="handelNav(5)">
            <span>页图</span>
          </li>
        </ul>
        <div class="listBox">
          <div class="listBoxInner">
            <div v-for="(item,index) in showData" :key="index" class="listBox_div">
              <div class="listBox_div_img">
                <img v-if="item.COVER" :src="item.COVER" alt="">
                <div v-else style="display: inline-block;width: 292px;height: 194px;line-height: 194px;text-align: center;font-weight: 600;font-size: 20px;color: #505050;background-color: #F5F5F5;">
                  {{ item.NAME }}
                </div>
                <div class="shadow" @click="goDetail(item.SHOW_RES_ID,item.SHOW_TYPE)">
                  <p>{{ item.SHOW_TITLE }}</p>
                  <div class="foots">
                    <span class="hot_time">{{ item.CREATE_DATE }}</span>
                    <span class="el-icon-view viewNumber">{{ item.SHOW_READ_SIZE }}</span>
                    <span class="el-icon-star-on viewNumber viewStar">{{ item.CONTENT_COLLECTION_NUMBER }}</span>
                  </div>
                </div>
                <span class="tip">{{ item.DICTIONARY_NAME }}</span>
              </div>
              <p>{{ item.SHOW_TITLE }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDataBookList, getDataArticleList, getDataTreeList, getdataNodeList, getDataArticlePageList, getDataBookImgList } from '@/api/api.js'
export default {
  data() {
    return {
      noIMG_list1: require('@/static/puwenDefaultImg.png'),
      noIMG_list2: require('@/static/puxuDefaultImg.png'),
      noIMG_list3: require('@/static/shuyeDefault.png'),
      bookData: [],
      showData: [],
      // peng1: require('@/static/peng1.png'),
      // peng2: require('@/static/peng2.png'),
      // peng3: require('@/static/peng3.png'),
      // peng4: require('@/static/peng4.png'),
      peng_jiapu_bgc: require('@/static/peng_jiapu_bgc.png'),
      currentIndex: 1,
      // listData: [
      //   { imgurl: require('@/static/tu1.png'), cloumName: '近代名人', message: '老宅是两百多年前的1811年建造的，是彭姓先祖由广东迁徙到大汾定居的四五十年后，由于经营木材生意发家', times: '2019-05-21 18:25', viewNumber: '2500', star: '2', name: '彭氏古楼之谜' },
      //   { imgurl: require('@/static/tu2.png'), cloumName: '近代名人', message: '老宅是两百多年前的1811年建造的，是彭姓先祖由广东迁徙到大汾定居的四五十年后，由于经营木材生意发家', times: '2019-05-21 18:25', viewNumber: '2500', star: '2', name: '彭氏古楼之谜' },
      //   { imgurl: require('@/static/tu3.png'), cloumName: '近代名人', message: '老宅是两百多年前的1811年建造的，是彭姓先祖由广东迁徙到大汾定居的四五十年后，由于经营木材生意发家', times: '2019-05-21 18:25', viewNumber: '2500', star: '2', name: '彭氏古楼之谜' },
      //   { imgurl: require('@/static/tu4.png'), cloumName: '近代名人', message: '老宅是两百多年前的1811年建造的，是彭姓先祖由广东迁徙到大汾定居的四五十年后，由于经营木材生意发家', times: '2019-05-21 18:25', viewNumber: '2500', star: '2', name: '彭氏古楼之谜' }
      // ],
      tipsimg3: require('@/static/jiapu_peng.png')
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      getDataBookList({ page: 1, limit: 4 }).then(res => {
        this.bookData = res.data.listMapData
      })
      getDataArticleList({ page: 1, limit: 4 }).then(res => {
        this.showData = res.data.listMapData
        for (var i = 0; i < this.showData.length; i++) {
          if (!this.showData[i].COVER) {
            this.showData[i].COVER = this.noIMG_list1
          }
        }
      })
    },
    getpuwenData() {
      getDataArticleList({ page: 1, limit: 4 }).then(res => {
        this.showData = res.data.listMapData
        for (var i = 0; i < this.showData.length; i++) {
          if (!this.showData[i].COVER) {
            this.showData[i].COVER = this.noIMG_list1
          }
        }
      })
    },
    getTreeData() {
      getDataTreeList({ page: 1, limit: 4 }).then(res => {
        this.showData = res.data.listMapData
        for (var i = 0; i < this.showData.length; i++) {
          if (!this.showData[i].COVER) {
            this.showData[i].COVER = this.noIMG_list2
          }
        }
      })
    },
    getNodeData() {
      getdataNodeList({ page: 1, limit: 4 }).then(res => {
        this.showData = res.data.listMapData
        var str = /^http/
        for (var i = 0; i < this.showData.length; i++) {
          if (!str.test(this.showData[i].COVER)) {
            this.showData[i].COVER = ''
          }
        }
      })
    },
    getShuYeData() {
      getDataArticlePageList({ page: 1, limit: 4 }).then(res => {
        this.showData = res.data.listMapData
        for (var i = 0; i < this.showData.length; i++) {
          if (!this.showData[i].COVER) {
            this.showData[i].COVER = this.noIMG_list3
          }
        }
      })
    },
    getImgData() {
      getDataBookImgList({ page: 1, limit: 4 }).then(res => {
        this.showData = res.data.listMapData
      })
    },
    handelNav(index) {
      this.currentIndex = index
      if (index == 1) {
        this.getpuwenData()
      } else if (index == 2) {
        this.getTreeData()
      } else if (index == 3) {
        this.getNodeData()
      } else if (index == 4) {
        this.getShuYeData()
      } else {
        this.getImgData()
      }
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.peng_jiapu{
    width: 100%;
    background-color: #4b4b4b;
    height: 750px;
    .content{
        height: 750px;
        background-color: #4b4b4b;
        .content_tip{
            height: 70px;
            text-align: center;
            line-height: 70px;
            background-color: #3b3b3b;
          img{
            width: 272px;
            height: 29px;
            margin-top: 20px;
          }
        }
        .showlist{
            width: 1200px;
            height: 320px;
            font-size: 0;
            position: relative;
          .showlistBox{
            width: 1200px;
            height: 320px;
            position: absolute;
            left: 0;
            top: 0;
          }
            img{
                width: 1200px;
                height: 320px;
            }
            .lilist{
                 margin-top: 43px;
                display: inline-block;
                width: 180px;
                overflow: hidden;
                 margin-left: 100px;
                img{
                  cursor: pointer;
                    width: 162px;
                    height: 211px;
                  border: 8px solid #ffffff;
                  -moz-box-shadow:1px 1px 3px rgba(74,74,74,.4);
                  -webkit-box-shadow:1px 1px 3px rgba(74,74,74,.4);
                  box-shadow:1px 1px 3px rgba(74,74,74,.4);
                  text-align: left;
                }
                p{
                  overflow: hidden;
                  white-space:nowrap;
                  text-overflow:ellipsis;
                    color: #333333;
                    margin-top: 5px;
                    font-size: 14px;
                  margin-left: 3px;
                }
            }
        }
        .peng_jiapu_nav{
            overflow: hidden;
            margin-top: 30px;
            ul{
                overflow: hidden;
                text-align: center;
                height: 30px;
                li{
                    display: inline-block;
                    height: 20px;
                    line-height: 20px;
                    padding: 5px 25px;
                    width: 30px;
                    span{
                        display: inline-block;
                        cursor: pointer;
                        color: #ffffff;
                        width: 30px;
                    }
                }
                .avtiveli{
                    background-color: #c3a14f;
                }
            }
            .listBox{
                overflow: hidden;
                overflow-x: auto;
                .listBoxInner{
                  width: 1200px;
                }
                .listBox_div{
                    height: 245px;
                    width: 292px;
                    display: inline-block;
                    margin-top: 20px;
                  margin-left: 5px;
                    .listBox_div_img{
                        width: 292px;
                        height: 194px;
                        overflow: hidden;
                        font-size: 0;
                        position: relative;
                        .shadow{
                            width: 292px;
                            height: 194px;
                            background-color:transparent;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 2;
                            cursor: pointer;
                            transition: 1s;
                            &:hover{
                              background-color:rgba(0,0,0,.3);
                            }
                            p{
                                background-color:transparent;
                                margin-top: 30px;
                                color: transparent;
                                transition: 0.5s;
                                height: 42px;
                                display:-webkit-box;
                                -webkit-line-clamp:3;
                                -webkit-box-orient:vertical;
                                overflow:hidden;
                                word-break: break-all;
                            }
                            .foots{
                                margin-top: 40px;
                                height: 25px;
                                line-height: 25px;
                                padding: 0 20px;
                                span{
                                    color: transparent;
                                    transition: 0.5s;
                                }
                                .viewNumber{
                                    margin-left: 40px;
                                }
                                .viewStar{
                                    margin-left: 13px;
                                }
                            }
                        }
                        .shadow:hover>p{
                                color: #ffffff;
                        }
                        .shadow:hover>.foots{
                            span{
                               color: #ffffff;
                            }
                        }
                        .tip{
                            position: absolute;
                            top: 6px;
                            left: 7px;
                            z-index: 3;
                            display: inline-block;
                            width: 65px;
                            height: 20px;
                            background-color:rgba(151,152,146,.8);
                            color: #ffffff;
                            line-height: 20px;
                            text-align: center;
                            border-radius: 5px;

                        }
                        img{
                            width: 292px;
                            height: 194px;
                        }
                    }
                    p{
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        height: 20px;
                        padding: 15px 16px;
                        background-color: #343434;
                        color: #fff;
                    }
                }
            }
        }
    }
}
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
@media screen and (max-width: 750px){
  .peng_jiapu{
    .content{
      .peng_jiapu_nav ul li{
        padding: 5px 10px;
      }
      .showlist{
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        .lilist p{
          text-align: center;
        }
        .lilist1{
          left: 36px;
        }
        .lilist2{
          left: 280px;
        }.lilist3{
           left: 546px;
         }
        .lilist4{
          left: 801px
        }
      }
    }
  }
}
</style>
